import en from './EN'
import zh from './CN'
import ko from './KO'
import ja from './JA'
import fr from './FR'
export default {
  en,
  zh,
  ko,
  ja,
  fr,
}